import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  MpupTransactionListItemComponent
} from './components/mpup-transaction-list-item/mpup-transaction-list-item.component'
import { MpupTransactionsViewComponent } from './components/mpup-transactions-view/mpup-transactions-view.component'
import { MpupSharedModule } from '../mpup-shared/mpup-shared.module'
import { PaginationModule } from '@spartacus/storefront'
import { MbI18nModule } from '../../translations/mb-i18n.module'

@NgModule({
  declarations: [MpupTransactionListItemComponent, MpupTransactionsViewComponent],
  imports: [
    CommonModule,
    MpupSharedModule,
    MbI18nModule,
    PaginationModule
  ]
})
export class MpupTransactionsModule { }
